import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import { COLOR_SECONDARY_MAIN, COLOR_WHITE } from "shared/theme/colors";

type Props = {
  unreadMessagesCount: number;
};

const UnreadTicketMessages: FC<Props> = ({ unreadMessagesCount }) => {
  const messagesCount = unreadMessagesCount > 99 ? "99+" : unreadMessagesCount;
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor={unreadMessagesCount ? COLOR_SECONDARY_MAIN : COLOR_WHITE}
      borderRadius="0.75rem"
      px={unreadMessagesCount > 9 ? "3px" : ""}
      height="1rem"
      minWidth="1rem"
      left={unreadMessagesCount >= 100 ? "-28px" : "-1.5rem"}
      position="absolute"
    >
      <Typography variant="bodySSemiBold" color={COLOR_WHITE}>
        {messagesCount}
      </Typography>
    </Box>
  );
};

export default UnreadTicketMessages;
